exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.width50 {\n  width: 50%\n}\n.width100 {\n  width: 100%\n}\n", ""]);

// exports
